import { currenciesActionTypes } from '../../actions/configurations/currenciesAction';

const CurrenciesReducers = (state = {}, action) => {
  switch (action.type) {
  case currenciesActionTypes.GET_CURRENCIES.LOADING: {
    const { getCurrenciesLoading } = action;
    return {
      ...state,
      getCurrenciesLoading,
    };
  }

  case currenciesActionTypes.GET_CURRENCIES.SUCCESS: {
    const { CurrenciesResults } = action;
    return {
      ...state,
      CurrenciesResults,
    };
  }

  case currenciesActionTypes.UPDATE_CURRENCIES.LOADING: {
    const { updateCurrenciesLoading } = action;
    return {
      ...state,
      updateCurrenciesLoading,
    };
  }

  case currenciesActionTypes.CREATE_CURRENCIES.LOADING: {
    const { createCurrenciesLoading } = action;
    return {
      ...state,
      createCurrenciesLoading,
    };
  }

  case currenciesActionTypes.DELETE_CURRENCIES.LOADING: {
    const { deleteCurrenciesLoading } = action;
    return {
      ...state,
      deleteCurrenciesLoading,
    };
  }

  case currenciesActionTypes.GET_CURRENCY_CONVERSION_RATE.LOADING: {
    const { getCurrencyConversionRateLoading } = action;
    return {
      ...state,
      getCurrencyConversionRateLoading,
    };
  }

  case currenciesActionTypes.GET_CURRENCY_CONVERSION_RATE.SUCCESS: {
    const { currencyConversionRateResults } = action;
    return {
      ...state,
      currencyConversionRateResults,
    };
  }

  case currenciesActionTypes.REFRESH_CURRENCY_CONVERSION_RATE.LOADING: {
    const { refreshCurrencyConversionRateLoading } = action;
    return {
      ...state,
      refreshCurrencyConversionRateLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default CurrenciesReducers;
